// intentTemplates — I-106: template-katalog för AI-chat-quick-start.
//
// Separerad från `IntentTemplatesMenu.tsx` så fast-refresh-regeln
// respekteras (komponenter och konstanter bor i olika filer).

import type { Intent } from '@/lib/intentTypes';

export interface IntentTemplate {
  id: string;
  label: string;
  description: string;
  intent: Intent;
  prompt: string;
}

export const INTENT_TEMPLATES: readonly IntentTemplate[] = [
  {
    id: 'order-to-invoice',
    label: 'Order → Faktura',
    description: 'Accounting-flow från order till faktura + kund-notis.',
    intent: 'build_new',
    prompt:
      'Bygg ett workflow för: order tas emot → skapa faktura → skicka e-postnotis till kund → markera som levererad.',
  },
  {
    id: 'support-automation',
    label: 'Support-ärende automation',
    description: 'Routing + SLA-eskalering för support-tickets.',
    intent: 'build_new',
    prompt:
      'Bygg ett workflow som: tar emot support-ärende → kategoriserar med AI → routar till rätt team → eskalerar om SLA bryts → notifierar kund vid lösning.',
  },
  {
    id: 'email-notification-chain',
    label: 'Email-notifikation-kedja',
    description: 'Multi-step email-kedja med godkännande-grindar.',
    intent: 'build_new',
    prompt:
      'Bygg ett workflow för approval-chain: trigger → skicka notis till manager → vänta på godkännande → vid godkänt: skicka bekräftelse; vid nej: skicka avslag.',
  },
  {
    id: 'data-sync',
    label: 'Data-sync mellan system',
    description: 'Periodisk sync mellan CRM och billing.',
    intent: 'build_new',
    prompt:
      'Bygg ett workflow för data-sync: cron-trigger (timme) → hämta nya kunder från CRM → transformera → upsert i billing-system → logga resultat.',
  },
  {
    id: 'onboarding',
    label: 'User-onboarding',
    description: 'Skapa konto + lägg i grupper + välkomstmail.',
    intent: 'build_new',
    prompt:
      'Bygg ett workflow för onboarding: ny-user-trigger → skapa M365-konto → lägg till i grupper baserat på avdelning → skicka välkomstmail med länkar.',
  },
  {
    id: 'offboarding',
    label: 'User-offboarding',
    description: 'Avaktivera konto, disable mailbox, överför data.',
    intent: 'build_new',
    prompt:
      'Bygg ett workflow för offboarding: termineringsdag → disable mailbox → överför filer till manager → ta bort från grupper → arkivera konto efter 30 dagar.',
  },
  {
    id: 'incident-response',
    label: 'Incident-response',
    description: 'Severity-routing + on-call + post-mortem-trigger.',
    intent: 'build_new',
    prompt:
      'Bygg ett workflow för incident-response: alert tas emot → klassificera severity → page on-call för high/critical → skapa incident-kanal → trigga post-mortem efter resolution.',
  },
  {
    id: 'contract-approval',
    label: 'Kontrakts-godkännande',
    description: 'Multi-signature flow för avtal.',
    intent: 'build_new',
    prompt:
      'Bygg ett workflow för kontrakts-godkännande: kontrakt uppladdat → legal review → manager approval → CEO-signatur om > X SEK → arkivera i DMS.',
  },
];
